export const pages = {
  login: '/login',
  loginRedirect: '/overview',
  bindUser: '/bind-user',
  resetPwd: '/reset-pwd',
};

export const TicketBoards = {
  draft: 'draft',
  story: 'story',
  subTask: 'sub-task',
};

export const UserLabels = {
  isTrialPassed: 'isTrialPassed',
};

export const StorageKeys = {
  detailSourcePath: 'detailSourcePath',
  detailSourceSearch: 'detailSourceSearch',
  detailHistory: 'bus:detail-history',
};
